// essential tokens
export const ICP_ICP_ID = 'icp'
export const BTC_ID = 'btc'
export const ETH_ID = 'eth'
export const SOL_ID = 'sol'

// IC tokens
export const NICP_ICP_ID = 'nicp'
export const BOB_ICP_ID = 'bob'
export const CKUSDC_ICP_ID = 'ckusdc'
export const CKUSDT_ICP_ID = 'ckusdt'
export const CKBTC_ICP_ID = 'ckbtc'
export const CKETH_ICP_ID = 'cketh'
export const CBBTC_ICP_ID = 'cbBTC'
export const USDT_ICP_ID = 'USDT'
export const USDC_ICP_ID = 'USDC'
export const GLDT_ICP_ID = 'gldt'
export const TCYCLES_ICP_ID = 'tcycles'
export const CKLINK_ICP_ID = 'cklink'
export const CKSHIB_ICP_ID = 'ckshib'
export const CKEURC_ICP_ID = 'ckeurc'
export const CKXAUT_ICP_ID = 'ckxaut'
export const CKWSTETH_ICP_ID = 'ckwsteth'
export const CKUNI_ICP_ID = 'ckuni'
export const CKPEPE_ICP_ID = 'ckpepe'
export const CKWBTC_ICP_ID = 'ckwbtc'
export const CKDOGE_ICP_ID = 'ckdoge'

// Odin tokens
export const ODINBTC_ID = 'OdinBtc'
export const ODINDOG_ID = '2jjj'

// ETH tokens
export const USDC_ETH_ID = 'usdc'
export const USDT_ETH_ID = 'usdt'
export const ICP_ETH_ID = 'icpeth'
export const CBBTC_ETH_ID = 'cbBTCeth'
export const CKBTC_ETH_ID = 'ckbtceth'
export const BOB_ETH_ID = 'bobeth'
export const GLDT_ETH_ID = 'gldteth'
export const LINK_ETH_ID = 'link'
export const SHIB_ETH_ID = 'shib'
export const EURC_ETH_ID = 'eurc'
export const XAUT_ETH_ID = 'xaut'
export const WSTETH_ETH_ID = 'wsteth'
export const UNI_ETH_ID = 'uni'
export const PEPE_ETH_ID = 'pepe'
export const WBTC_ETH_ID = 'wbtc'

// ARB tokens
export const ETH_ARB_ID = 'etharb'
export const USDC_ARB_ID = 'usdcarb'
export const BOB_ARB_ID = 'bobarb'
export const ICP_ARB_ID = 'icparb'
export const CBBTC_ARB_ID = 'cbbtcarb'
export const CKBTC_ARB_ID = 'ckbtcarb'
export const GLDT_ARB_ID = 'gldtarb'

// BASE tokens
export const ETH_BASE_ID = 'ethbase'
export const USDC_BASE_ID = 'usdcbase'
export const ICP_BASE_ID = 'icpbase'
export const BOB_BASE_ID = 'bobbase'
export const CBBTC_BASE_ID = 'cbbtcbase'
export const CKBTC_BASE_ID = 'ckbtcbase'
export const GLDT_BASE_ID = 'gldtbase'

// SOL tokens
export const SOL_USDC_ID = 'solusdc'

// DOGE tokens
export const DOGE_ID = 'dogecoin'

// HyperCore / HyperEVM tokens
export const USDC_HYPERCORE_SPOT_ID = 'usdc-hypercore-spot'
export const USDC_HYPERCORE_PERP_ID = 'usdc-hypercore-perp'
export const USDC_HYPEREVM_ID = 'usdc-hyperevm'
